import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row, Skeleton } from 'antd'
import { Formik } from 'formik'

import { SignupValues } from 'core/application/account/common'
import { EmployeeSignupValues } from 'core/application/account/employeeSignup'
import tryToGetCredentials from 'core/application/account/tryToGetCredentials'
import store from 'core/application/commons/localStorage'

import PasswordInput from 'common/components/dataEntry/formik/FormikPasswordField'
import Input from 'common/components/dataEntry/formik/FormikStyledInputField'
import Button from 'common/components/general/Button'
import Content from 'common/components/layout/Content'
import Footer from 'common/components/layout/Footer'
import Layout from 'common/components/layout/Layout'
import PageHeader from 'common/components/onBoarding/PageHeader'
import { generalPasswordRegx } from 'common/components/utils/Regx'

import useCommandRequest from 'common/hooks/useCommandRequest'
import useUrlQueryParam from 'common/hooks/useUrlQueryParam'

import useQueryRequest from '../../common/hooks/useQueryRequest'
import AccountHeader from '../AccountHeader'
import RightSection from '../RightSection'
import { formValidator } from './Utils'

import '../AccountStyles.less'

type EmployeeSignupProps = {
  initialValues: SignupValues
  headerTitle: string
  signupController: (signup: EmployeeSignupValues) => Promise<any>
  signupFlowPath: string
}

const EmployeeSignup: React.FC<EmployeeSignupProps> = (props) => {
  const { t: translate } = useTranslation()
  const code = useUrlQueryParam('code')
  const [sendCommand, isCommandLoading] = useCommandRequest<any>()
  const [showSignUpPage, setshowSignUpPage] = useState<boolean>(false)

  const headerItems: string[] = [
    translate('admin-signup.signup.header-item1'),
    translate('admin-signup.signup.header-item2'),
    translate('admin-signup.signup.header-item3'),
  ]

  useEffect(() => {
    ;(async () => {
      const res = await sendCommand(() =>
        tryToGetCredentials({
          code: code,
        }),
      )
      if (res.completed && res.data != '') {
        store.setToken(res.data.token)
        window.location.replace(props.signupFlowPath)
      } else {
        setshowSignUpPage(true)
      }
    })()
  }, [])

  const [password, setPassword] = useState<string>('')
  const [initialValues] = useState<SignupValues>(props.initialValues)

  const onSubmit = async (values: SignupValues) => {
    const request: EmployeeSignupValues = {
      code: code ? code : '',
      password: values.password,
    }
    const result = await sendCommand(() => props.signupController(request))
    if (result) {
      store.setToken(result.data.token)
      window.location.href = props.signupFlowPath
    }
  }

  return (
    <div>
      {showSignUpPage ? (
        <Layout className="signup-responsive-layout">
          <Content>
            <Formik
              enableReinitialize={true}
              validationSchema={formValidator(password)}
              initialValues={initialValues}
              onSubmit={onSubmit}
            >
              {(formik) => (
                <form onSubmit={formik.handleSubmit} autoComplete="off">
                  <Row>
                    <Col xs={23} sm={19} md={19} lg={16}>
                      <Row justify="center">
                        <Col span={24} sm={{ offset: 2 }} xs={{ offset: 1 }} md={{ offset: 5 }} lg={{ offset: 10 }}>
                          <div className="pt-16 mb-64">
                            <AccountHeader eeSignUp={parseInt(initialValues.productId as string)} />
                          </div>
                        </Col>
                      </Row>
                      <Row justify="center" align="middle">
                        <Col xs={23} sm={23} md={15} lg={10}>
                          <Row align="middle" justify="center">
                            <Col xs={24} md={24}>
                              <PageHeader title={translate('admin-signup.signup.title')} content="" />
                            </Col>
                          </Row>

                          <Row gutter={10} className="form__row">
                            <Col xs={24} lg={12} xl={12} className="pt-24">
                              <Input className="formik_input" label="First Name" name="firstName" disabled></Input>
                            </Col>
                            <Col xs={24} lg={12} xl={12} className="pt-24">
                              <Input label="Last Name" name="lastName" disabled></Input>
                            </Col>
                          </Row>

                          <Row className="form__row">
                            <Col xs={24} lg={24} xl={24} className="pt-24">
                              <Input name="email" label="Email" disabled></Input>
                            </Col>
                          </Row>

                          <Row className="form__row">
                            <Col xs={24} lg={24} xl={24}>
                              <PasswordInput
                                label="Password"
                                name="password"
                                placeholder="choose a password"
                                popover={
                                  window.innerWidth > 767 ||
                                  (formik.values.password !== '' &&
                                    formik.values.password !== undefined &&
                                    !formik.values.password.match(generalPasswordRegx) &&
                                    true)
                                }
                                popoverPlacement={window.innerWidth < 767 && 'topRight'}
                                setPassword={(password: string) => {
                                  setPassword(password)
                                }}
                              ></PasswordInput>
                            </Col>
                          </Row>

                          <Row className="form__row">
                            <Col xs={24} lg={24} xl={24}>
                              <PasswordInput
                                label="Password"
                                name="passwordConfirmation"
                                placeholder="retype password"
                                setPassword={() => {}}
                              ></PasswordInput>
                            </Col>
                          </Row>

                          <Row className="form__row ant-row__align-item-end pt-16 pb-16">
                            <Col xs={24} lg={24}>
                              <Button
                                type="default"
                                icon="fa fa-arrow-right"
                                iconPosition="right"
                                htmlType="submit"
                                className="button__large"
                                disabled={!formValidator(password).isValidSync(formik.values)}
                                loading={isCommandLoading}
                              >
                                Create account
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      xs={0}
                      sm={0}
                      lg={8}
                      xl={8}
                      className="account-right-section-signup account-right-section__fixed"
                    >
                      <RightSection headerTitle={props.headerTitle} headerItems={headerItems} />
                    </Col>
                  </Row>
                </form>
              )}
            </Formik>
          </Content>
          <Footer />
        </Layout>
      ) : (
        <Layout></Layout>
      )}
    </div>
  )
}

export default EmployeeSignup
